import { render, staticRenderFns } from "./MyQuotationDetailContact.vue?vue&type=template&id=5f7e59a4&"
import script from "./MyQuotationDetailContact.vue?vue&type=script&lang=js&"
export * from "./MyQuotationDetailContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f7e59a4')) {
      api.createRecord('5f7e59a4', component.options)
    } else {
      api.reload('5f7e59a4', component.options)
    }
    module.hot.accept("./MyQuotationDetailContact.vue?vue&type=template&id=5f7e59a4&", function () {
      api.rerender('5f7e59a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/App/VSL/MyQuotation/MyQuotationDetail/MyQuotationDetailContact.vue"
export default component.exports